import { useEffect, useMemo } from "react";
import useSWR, { CacheInterface } from "swr";
import { ConfigInterface, fetcherFn, keyInterface, mutateInterface, responseInterface, triggerInterface } from "swr/dist/types";
import { useOfflineCacheContext } from "./OfflineCacheContext";

export type UseSWRCacheHook = () => { cache: CacheInterface, mutate: mutateInterface, trigger: triggerInterface };

export const useSWROffline = <Data = any, Error = any>(
    key: keyInterface,
    fn?: fetcherFn<Data>,
    config?: ConfigInterface<Data, Error>
): responseInterface<Data, Error> => {

    const { online, getItem, setItem, clearItem } = useOfflineCacheContext()

    const fetcher: any = fn ? async () => {

        if (!online) {
            const cachedItem = getItem<Data>(key);
            if (!cachedItem) throw Error("Cannot fetch offline is item not in offline cache")
            return cachedItem as any;
        }
        return await fn();
    } : null


    const handleSuccess: ConfigInterface["onSuccess"] = (data, key, config) => {
        // console.log("handleSuccess", data, key, config)
        setItem(key, data);
    };

    const handleError: ConfigInterface["onError"] = (data, key, config) => {
        console.log("handleError", data, key, config)
        clearItem(key);
    }

    const initialItem = useMemo(() => getItem(key), []);  // eslint-disable-line

    let confs: ConfigInterface = {
        ...config,
        onError: handleError,
        onSuccess: handleSuccess,
        initialData: !online ? initialItem : config?.initialData
    }

    const response = useSWR(key, fetcher, confs);

    useEffect(() => {
        setItem(key, response.data);
    }, [response.data]);  // eslint-disable-line

    return response;
};
